import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

const Project4Card = () => {
    return (
        <Container>
            <Row>
                <Col lg={10} className='mx-auto'>
                    <p className='lead'>
                        During the Coronavirus pandemic, I wanted to understand how well a generative AI model could
                        learn the dynamics of an epidemic from simulation alone. Virus AI modeled a synthetic
                        population in code and let a generative model evolve an abstract "DNA" trait vector purely
                        within that simulation, with no real biological data involved.
                    </p>

                    <h3 className='text-uppercase mt-4 fs-6 fw-bold'>What I Built</h3>
                    <ul>
                        <li>A simulated population with configurable mobility, interaction, and susceptibility parameters.</li>
                        <li>A generative model that proposed synthetic trait vectors and observed how each performed within the simulation.</li>
                        <li>A feedback loop that let the model iteratively refine its trait proposals based on simulated outcomes.</li>
                    </ul>

                    <h3 className='text-uppercase mt-4 fs-6 fw-bold'>Outcome</h3>
                    <p>
                        The exercise showed that a generative model could learn meaningful patterns from a closed
                        simulation without any real-world data, and was a practical, low-stakes way to build
                        intuition for how generative AI and evolutionary optimization interact.
                    </p>

                    <p className='text-muted mb-0'><i>Completed May 2021</i></p>
                </Col>
            </Row>
        </Container>
    )
}

export default Project4Card;
